const { connectionData, endpoint } = require("./apiConnection");
export const dataUsers = async () => connectionData(endpoint,'users','GET');
export const addUser = async (body) => connectionData(endpoint,'users','POST',body);
export const getUsers = async () => JSON.parse(localStorage.getItem('user'));
export const getFathers = async () => JSON.parse(localStorage.getItem('father'));
export const delteUser = async (id) => connectionData(endpoint,'users/'+id,'DELETE');